import { Component, OnInit,ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { Sort } from '@angular/material/sort';

import { DataService } from './../../data.service';

@Component({
  selector: 'app-recordtypelist',
  templateUrl: './recordtypelist.component.html',
  styleUrls: ['./recordtypelist.component.scss']
})
export class RecordTypeListComponent implements OnInit {

  @Input() metaobjectid : string;
  @Input() objectname : string;

  matSort: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaobjectId = "";
  objectName = "";
  metafieldList=[];
  recordTypeList=[];
  
  displayedColumns: string[] = ['id', 'displayname', 'name','description',"modifiedby","modifieddate", 'active'];
  dataSource = new MatTableDataSource();

  sortingField = {
    fieldName: 'displayname',
    order: 'ASC'
  }

  sortDataRecordType(sort: Sort) {
    console.log("sort", sort);
    if (!sort.active || sort.direction === '') {
      //default sorting
      this.sortingField.fieldName = "name";
      this.sortingField.order = "ASC";
    }
    else
    {
      const isAsc = sort.direction.toLocaleUpperCase() === 'ASC';
      this.sortingField.fieldName = sort.active;
      if (isAsc) {
        this.sortingField.order = "ASC";
      }
      else {
        this.sortingField.order = "DESC";
      }
    }
    
    this.getRecordTypes().then(res => {
      console.log("response33333",res);

    }); 
  }


  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder,
    private dataService: DataService) { }

  ngOnInit() {
    
    this.metaobjectId = this.metaobjectid;
    this.objectName = this.objectname;

    //load record types
    this.getRecordTypes().then(res => {
      console.log("response222221",res);

    }); 

  }

  newRecordType()
  {
    this.router.navigateByUrl('/home/recordtype/new/'+ this.metaobjectId + '/' + this.objectName );  
  }

  layoutAssignment()
  {
    this.router.navigateByUrl('/home/recordtype/layoutassignment/edit/'+ this.objectName + '/' + this.metaobjectId + '/profile');  
  }

  getRecordTypes(){
    return new Promise((resolve, reject) => {

      console.log("getRecordTypes");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid:localStorage.getItem("crm_userid"),
        username:localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          sortfield: this.sortingField.fieldName,
          sortorder: this.sortingField.order,  
          recordtype: {
            metaobjectid: this.metaobjectid
          }
        }
      }
      console.log("postOption", postOption)
      this.isLoading = true;
      this.dataService.getRecordTypes(postOption).subscribe(      
        res => {
          console.log(res);
          if(res !== null && res.success == 1){
            this.recordTypeList = res.data.recordtypes;
            //assign table data will refresh it automatically
            this.dataSource.data = this.recordTypeList;

            this.isLoading = false;
            resolve(null);
          }
          else{
            console.log("No metafields data!");
            this.errorMessage = (res!= null ? res.message : "No metafields data!");
            this.isError = true;  
            this.isLoading = false;
            resolve(null);
          }
        },
        err =>{
          console.log("Error***:",err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
  
      );
      
    });
  }


}
